export const METER_RKOEFF_LABEL = 'Расчетный коэфф.';

export function isPriceCategoryVisible(env = process.env.REACT_APP_NAME_ENV) {
    return env === 'garant' || env === 'renergy';
}
